<template>
  <!-- 电脑端-复制 -->
  <a
    id="u_c_9B8817"
    class="normal u_c_9B8817"
    href="javascript:;"
    @click="u_c_9B8817_event_86KO17($event)"
    ><div id="u_c_7Z4518" class="normal u_c_7Z4518" v-show="compData.tipState">
      {{ `${compData.copysucc}` }}
    </div></a
  >
</template>
<script>
import { reactive, provide, inject, onMounted, watch, ref, computed } from "vue"
import Language from "@/hooks/language.js"
import Router from "@/hooks/router.js"
import bridge from "@/utils/sdkBridge.js"
import * as request from "@/api/request"
import * as utils from "@/utils"
import * as _ from "lodash"
import useClipboard from "vue-clipboard3"
export default {
  name: "",
  components: {},
  setup() {
    const { curLang, getLangTxt, langData } = Language()
    const routerData = inject("routerData", {})
    const pageData = inject("pageData", {})
    const COMP_DATA_LANG = {
      default: {
        tipState: false,
        giftCode: "这里填写对应的礼包码或其他复制内容",
        copysucc: "复制成功\uFF08自动替换多语言\uFF09",
      },
      "vi-VN": {
        tipState: false,
        giftCode: "HS888",
        copysucc: "复制成功\uFF08自动替换多语言\uFF09",
      },
    }
    const compData = reactive(
      COMP_DATA_LANG[curLang] || COMP_DATA_LANG["vi-VN"] || {}
    )

    const router = Router()

    // 自定义setup - 开始
    const SUCC_TIPS = {
      default: "Copied to clipboard",
      "ar-SR": "تم النسخ إلى الحافظة",
      "id-ID": "Disalin ke papan klip",
      "ja-JP": "コピーしました",
      "ko-KR": "클립보드로 복사되었습니다.",
      "th-TH": "คัดลอกไปยังคลิปบอร์ดแล้ว",
      "vi-VN": "Đã sao chép",
      "zh-CN": "已复制至剪贴板",
      "zh-TW": "已複製至剪貼板",
    }

    compData.copysucc = SUCC_TIPS[curLang] || SUCC_TIPS.default

    const gaClickUpload = inject("gaClickUpload", () => {})

    const { toClipboard } = useClipboard()
    const copy = async () => {
      try {
        await toClipboard(compData.giftCode)
        compData.tipState = true
      } catch (e) {
        console.log(e)
      }
    }

    watch(
      () => compData.tipState,
      (value) => {
        if (value) {
          setTimeout(() => {
            compData.tipState = false
          }, 2000)
        }
      }
    )
    // 复制的click事件
    const u_c_9B8817_event_86KO17 = async (e) => {
      try {
        copy()
        let gameId =
          utils.getUrlParams("gameId") ||
          utils.getUrlParams("gameID") ||
          utils.getUrlParams("game_id")

        let gtm_filter_res = utils.getCookie(`zz_gtm_filter_${gameId}_copy`)
        if (!gtm_filter_res) {
          gaClickUpload("gtm-click-copy")
          if (gameId) {
            utils.setCookie(`zz_gtm_filter_${gameId}_copy`, 1, 30)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    // 自定义setup - 结束
    return { u_c_9B8817_event_86KO17, pageData, routerData, compData, langData }
  },
}
</script>
<style lang="scss" scoped>
.default {
  .u_c_9B8817.normal {
    position: absolute;
    width: 4.63vh;
    height: 4.63vh;
    background-image: url(https://gimages.olgamevn.com/aws_s3/img?s=/platform/one_image/2022/08/16602889214213.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    top: 68.43vh;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 45vh;
  }
}
.default {
  .u_c_7Z4518.normal {
    position: absolute;
    font-size: 1.67vh;
    color: white;
    bottom: 110%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    padding: 0.74vh 1.85vh;
    background: #555;
    border-radius: 12px;
  }
}
.vi-VN {
  .u_c_9B8817.normal {
    position: absolute;
    width: 4.63vh;
    height: 4.63vh;
    background-image: url(https://gimages.olgamevn.com/aws_s3/img?s=/platform/one_image/2022/08/16602889214213.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    top: 68.43vh;
    left: 50%;
    transform: translateX(-50%);
    margin-left: 45vh;
  }
}
.vi-VN {
  .u_c_7Z4518.normal {
    position: absolute;
    font-size: 1.67vh;
    color: white;
    bottom: 110%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    padding: 0.74vh 1.85vh;
    background: #555;
    border-radius: 12px;
  }
}
</style>
